import { useSearchParams } from 'react-router-dom'

/**
 * Откуда открыто окно (RP-FB56): из сканирования. В адресе окна — только короткое и не секретное: `from=scan`, `frame` (номер кадра на
 * устройстве), `name` (прочитанное название, до 120 знаков) и `barcode`. Кадр в адрес не кладётся; обновление страницы его теряет,
 * а название и штрихкод остаются.
 */
export interface ScanOrigin {
  frameId: string
  name: string
  barcode: string | null
}

export function useScanOrigin(): ScanOrigin | null {
  const [params] = useSearchParams()
  if (params.get('from') !== 'scan') return null
  const barcode = (params.get('barcode') ?? '').trim()
  return { frameId: params.get('frame') ?? '', name: (params.get('name') ?? '').trim(), barcode: barcode === '' ? null : barcode }
}
